import { getEnv } from "@/utils";
import APIAbstract from "./apiAbstract";

declare const APP_VERSION: string;

export default class PublicTribesApi extends APIAbstract {
  constructor() {
    super({
      baseUrl: `${getEnv("treebalApiUrlTribe", "notSet")}`,
      basePath: "api/v1/public-tribes",
    });
    this.client.interceptors.request.use(async (config) => {
      /**
       * Treebal-Client header needed. for public tribe until it's. removed
       * @deprecated
       */
      config.headers["Treebal-Client"] = `interface-pro v${APP_VERSION}`;

      return config;
    });
  }
}
